import { GoogleClientIdKey } from '../utils/symbols'

export default defineNuxtPlugin((nuxt) => {
	const runtime = useRuntimeConfig()
	const { google } = runtime.public

	if (!google.auth?.key) return console.error('No Google authentication client id found')
	nuxt.vueApp.provide(GoogleClientIdKey, google.auth?.key)
})
